import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { CircularProgress, IconButton, Stack, Tooltip } from "@mui/material";

import {
	SECTION_SPEC_ROTATION,
	type SectionSpecRotation,
} from "../../models/SectionSpecRotation";

interface SectionSpecRotateButtonsProps {
	label: string;
	disabled: boolean;
	rotating: boolean;
	onRotate: (rotation: SectionSpecRotation) => void;
}

export const SectionSpecRotateButtons = ({
	label,
	disabled,
	rotating,
	onRotate,
}: SectionSpecRotateButtonsProps) => (
	<Stack direction="row" alignItems="center" spacing={0.5}>
		<Tooltip title={`Rotate ${label} left`}>
			<span>
				<IconButton
					aria-label={`Rotate ${label} left`}
					size="small"
					disabled={disabled || rotating}
					onClick={() => onRotate(SECTION_SPEC_ROTATION.LEFT)}
				>
					{rotating ? (
						<CircularProgress size={16} />
					) : (
						<RotateLeftIcon fontSize="small" />
					)}
				</IconButton>
			</span>
		</Tooltip>
		<Tooltip title={`Rotate ${label} right`}>
			<span>
				<IconButton
					aria-label={`Rotate ${label} right`}
					size="small"
					disabled={disabled || rotating}
					onClick={() => onRotate(SECTION_SPEC_ROTATION.RIGHT)}
				>
					{rotating ? (
						<CircularProgress size={16} />
					) : (
						<RotateRightIcon fontSize="small" />
					)}
				</IconButton>
			</span>
		</Tooltip>
	</Stack>
);
